let RestApiBase = "https://radiomegaton.hr/wp-json/wp/v2";

if (process.env.NODE_ENV === "development") 
    RestApiBase = "https://radiomegaton.hr/wp-json/wp/v2";

export function getPosts() {
    return fetch(`${RestApiBase}/posts?_embed`)
    .then(response => response.json());
}

export function getPost(slug) {
    return fetch(`${RestApiBase}/posts?slug=${slug}&_embed`)
    .then(response => response.json());
}

export function getPlaylist() {
    return [
        {time: "12:22", song: "Hajde da ludujemo", artist: "Tajči"},
        {time: "12:18", song: "Oduzimaš mi dah", artist: "Colonia"},
        {time: "12:13", song: "Zorica", artist: "Mejaši"},
        {time: "12:09", song: "Tek je 12 sati", artist: "E.T."},
        {time: "12:05", song: "Tri Sam Ti Zime Šaptala Ime", artist: "Magazin"},
    ];
}